import React from "react";
import {
  LocalizationProvider,
  MobileDateTimePicker,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

const MDDateAndTimePicker = ({
  label = "Select Date & Time",
  value,
  onChange,
  sx = {},
  error = false,
  helperText = "",
  ...rest
}) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <MobileDateTimePicker
        label={label}
        value={value || dayjs(new Date())}
        onChange={onChange}
        openTo="day"
        disablePast
        className="custom_datePicker"
        slotProps={{
          textField: {
            error,
            helperText,
            sx: {
              "& .MuiOutlinedInput-root": {
                borderRadius: "10px",
                fontFamily: "Inter, sans-serif",
                fontSize: "14px",
              },
              "& .MuiInputBase-root": {
                fontFamily: "Inter, sans-serif",
                borderRadius: "10px",
              },
              "& fieldset": {
                fontFamily: "Inter, sans-serif",
                borderRadius: "10px",
              },

              "& .MuiPickersSectionList-section": {
                fontFamily: "Inter, sans-serif",
                fontSize: "14px",
              },

              ...sx,
            },
          },
          dialog: {
            className: "custom_datepicker_dialog",
          },
        }}
        {...rest}
      />
    </LocalizationProvider>
  );
};

export default MDDateAndTimePicker;
